import React,{useEffect,useState} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCalendar,FiPhone,FiClock}=FiIcons;

const UploadForm=()=> {
  const [widgetLoaded,setWidgetLoaded]=useState(false);

  useEffect(()=> {
    // Only load the widget script when the user scrolls to this section
    const observer=new IntersectionObserver((entries)=> {
      const entry=entries[0];
      if (entry.isIntersecting && !widgetLoaded) {
        const script=document.createElement('script');
        script.src='https://resource.sayify.pro/cdn/widget.js';
        script.async=true;
        
        // Set configuration attributes from your snippet
        script.setAttribute('data-slug', 'customer-inquiry');
        script.setAttribute('data-mode', 'inline-form');
        script.setAttribute('data-base-url', 'https://crcnu.sayify.pro');
        script.setAttribute('data-label', 'Feedback');
        script.setAttribute('data-color', '#C86A4A');
        script.setAttribute('data-position', 'bottom-right');
        script.setAttribute('data-description', 'Share your feedback by voice');
        script.setAttribute('data-inline-height', '600');
        script.setAttribute('data-auto-height', 'true');
        script.setAttribute('data-container', 'sayify-widget-container');

        script.onload=()=> setWidgetLoaded(true);
        document.body.appendChild(script);
      }
    },{threshold: 0.1});

    const formSection=document.getElementById('upload-form');
    if (formSection) {
      observer.observe(formSection);
    }

    return ()=> {
      if (formSection) {
        observer.unobserve(formSection);
      }
    };
  },[widgetLoaded]);

  return (
    <section id="upload-form" className="py-20 bg-gray-900">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-white mb-4">Schedule Your Free Lower Internet Bill Consultation</h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-4">
            Connect with our NYC business internet specialist to discuss your current bill and potential savings.
          </p>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            Learn how to negotiate your internet bill effectively and discover if you're paying above the average internet bill NYC businesses should expect. 
            Our Manhattan business internet experts will provide a personalized assessment of your current NYC business internet service costs.
          </p>
        </motion.div>

        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="bg-gray-800 p-8 rounded-xl border border-gray-700"
        >
          {/* Benefits Section */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="text-center">
              <div className="bg-gradient-to-r from-red-500 to-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiCalendar} className="text-2xl text-white" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Free NYC Business Internet Consultation</h3>
              <p className="text-gray-400 text-sm">No cost, no obligation discussion about your Manhattan business internet costs</p>
            </div>
            <div className="text-center">
              <div className="bg-gradient-to-r from-red-500 to-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiClock} className="text-2xl text-white" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Lower Internet Bill Analysis</h3>
              <p className="text-gray-400 text-sm">Fast assessment comparing your bill to the average internet bill NYC businesses pay</p>
            </div>
            <div className="text-center">
              <div className="bg-gradient-to-r from-red-500 to-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiPhone} className="text-2xl text-white" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Expert Guidance</h3>
              <p className="text-gray-400 text-sm">Learn how to negotiate internet bill terms from our NYC business internet specialists</p>
            </div>
          </div>

          {/* Transparency Disclaimer */}
          <div className="bg-yellow-900/20 border border-yellow-600 rounded-lg p-4 mb-6">
            <p className="text-yellow-200 text-sm leading-relaxed text-center">
              <strong className="text-yellow-400">Please note:</strong> Not all customers will qualify for price reductions. Eligibility may be affected by existing contracts, current promotional pricing, Dedicated Internet Access (DIA) plans, or if you're already receiving the best available rate from your provider.
            </p>
          </div>

          {/* New Sayify Widget Container */}
          <div className="bg-white rounded-lg p-2 min-h-[600px]">
            <div id="sayify-widget-container">
              {/* The widget will inject the form here */}
              {!widgetLoaded && (
                <div className="flex items-center justify-center h-[600px] text-gray-500">
                  Loading inquiry form...
                </div>
              )}
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center">
            <p className="text-gray-400 text-sm mb-4">
              During this lower internet bill consultation, we'll review your current NYC business internet service costs and identify potential savings opportunities.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <div className="flex items-center gap-2 text-green-400">
                <span>✓</span>
                <span>Confidential & Secure</span>
              </div>
              <div className="flex items-center gap-2 text-green-400">
                <span>✓</span>
                <span>Voice-Enabled Feedback</span>
              </div>
              <div className="flex items-center gap-2 text-green-400">
                <span>✓</span>
                <span>Professional Assessment</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UploadForm;